import { ReduxModule } from '../../BaseAppProvider/BaseAppProvider';
import { userReducer } from './reducers';
import rootSaga from './sagas';

export const getXAuthModule = (): ReduxModule => ({
  id: 'XAuth',
  reducerMap: {
    user: userReducer
  },
  sagas: [rootSaga]
});
